import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=08a8e4a9"
import script from "./Combobox.vue?vue&type=script&lang=js"
export * from "./Combobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports